import client from '../utils/client';
import { branchesUrl } from '../store/constants/api';
import { cookieConstants } from "../store/constants";
import { Cookies } from "react-cookie";

const cookies = new Cookies();

export const branchService = {
  branchesList,
  addBranch,
  getBranch,
  updateBranch
}

function branchesList(pageID, perPage, searchInput) {
  let searchQuery = '';
  if(searchInput !== '') {
    searchQuery = '&s=' + searchInput;
  }
  return client.get(branchesUrl + '?page=' + pageID + '&per_page=' + perPage + searchQuery)
    .then((response) => {
      return response
    })
    .catch(handleResponse);
}

function addBranch(formDate) {
  return client.post(branchesUrl + '/create', formDate)
    .then((response) => {
      return response
    })
    .catch(handleResponse);
}

function getBranch(branchID) {
  return client.get(branchesUrl + '/' + branchID + '/show')
    .then((response) => {
      return response
    })
    .catch(handleResponse);
}

function updateBranch(formDate) {
  return client.post(branchesUrl + '/update', formDate)
    .then((response) => {
      return response
    })
    .catch(handleResponse);
}

function logout() {
  cookies.remove(cookieConstants.TOKEN, { path: "/" });
  cookies.remove(cookieConstants.USER, { path: "/" });
}

function handleResponse(response) {
  response = response.response
  var data = response.data;
  if (!response.ok) {
    if (response.status === 401) {
      logout();
      window.location.reload(true);
    }
    const error = data.errors;
    return Promise.reject(error);
  }

  return data;
}